import type { FrequencyColorMap } from '@/types';

/** Deuteranopia (red-green) — shifted to blue-orange spectrum */
export const DEUTERANOPIA_COLORS: FrequencyColorMap = {
  1: '#D4A017',  // warm gold
  2: '#E8901E',  // orange
  3: '#F5C542',  // bright yellow
  4: '#87CEEB',  // sky blue
  5: '#1E90FF',  // dodger blue
  6: '#4169E1',  // royal blue
  7: '#000080',  // navy
  8: '#4B0082',  // indigo
  9: '#8A2BE2',  // blue violet
  10: '#DA70D6', // orchid
  11: '#FF69B4', // hot pink
  12: '#F5F5F5', // white smoke
};

/** Protanopia — luminance-differentiated palette */
export const PROTANOPIA_COLORS: FrequencyColorMap = {
  1: '#1A1A1A',  // near black (darkest)
  2: '#4A3728',  // dark brown
  3: '#8B7355',  // tan
  4: '#D4C5A9',  // light tan
  5: '#F0E68C',  // khaki
  6: '#87CEEB',  // sky blue
  7: '#4682B4',  // steel blue
  8: '#1E3A5F',  // dark blue
  9: '#6B5B95',  // purple
  10: '#B8A9C9', // light purple
  11: '#E8D5B7', // champagne
  12: '#FFFFFF',  // white (lightest)
};

/** Tritanopia (blue-yellow) — shifted to red-cyan spectrum */
export const TRITANOPIA_COLORS: FrequencyColorMap = {
  1: '#8B0000',  // dark red
  2: '#DC143C',  // crimson
  3: '#FF6347',  // tomato
  4: '#FF8C00',  // dark orange
  5: '#FFB347',  // pastel orange
  6: '#20B2AA',  // light sea green
  7: '#008B8B',  // dark cyan
  8: '#2F4F4F',  // dark slate
  9: '#800080',  // purple
  10: '#DA70D6', // orchid
  11: '#FF1493', // deep pink
  12: '#F0F0F0', // near white
};

export type ColorBlindMode = 'none' | 'deuteranopia' | 'protanopia' | 'tritanopia';

export function getFrequencyColors(mode: ColorBlindMode): FrequencyColorMap {
  switch (mode) {
    case 'deuteranopia': return DEUTERANOPIA_COLORS;
    case 'protanopia': return PROTANOPIA_COLORS;
    case 'tritanopia': return TRITANOPIA_COLORS;
    default: return null as never; // caller should use default FREQUENCY_COLORS
  }
}
